// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceModelId } from './DeviceModel';
import { deviceChannelDatatypeEnum } from './DeviceChannelDatatypeEnum';
import { deviceChannelRoleEnum } from './DeviceChannelRoleEnum';
import { z } from 'zod';
export const deviceModelChannelId = (z.number());
export const deviceModelChannel = z.object({
    id: deviceModelChannelId,
    device_model_id: deviceModelId,
    key: z.string(),
    kind: z.string(),
    label: z.string(),
    datatype: deviceChannelDatatypeEnum,
    unit: z.string().nullable(),
    description: z.string().nullable(),
    role: deviceChannelRoleEnum,
    min_value: z.number().nullable(),
    max_value: z.number().nullable(),
    default_value: z.number().nullable(),
    is_accumulator: z.boolean(),
    reset_config_key: z.string().nullable(),
    seed_config_key: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const deviceModelChannelInitializer = z.object({
    id: deviceModelChannelId.optional(),
    device_model_id: deviceModelId,
    key: z.string(),
    kind: z.string(),
    label: z.string(),
    datatype: deviceChannelDatatypeEnum,
    unit: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    role: deviceChannelRoleEnum,
    min_value: z.number().optional().nullable(),
    max_value: z.number().optional().nullable(),
    default_value: z.number().optional().nullable(),
    is_accumulator: z.boolean().optional(),
    reset_config_key: z.string().optional().nullable(),
    seed_config_key: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const deviceModelChannelMutator = z.object({
    id: deviceModelChannelId.optional(),
    device_model_id: deviceModelId.optional(),
    key: z.string().optional(),
    kind: z.string().optional(),
    label: z.string().optional(),
    datatype: deviceChannelDatatypeEnum.optional(),
    unit: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    role: deviceChannelRoleEnum.optional(),
    min_value: z.number().optional().nullable(),
    max_value: z.number().optional().nullable(),
    default_value: z.number().optional().nullable(),
    is_accumulator: z.boolean().optional(),
    reset_config_key: z.string().optional().nullable(),
    seed_config_key: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=DeviceModelChannel.js.map